var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Selected_Card",
    "data-name": "Selected Card",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 388.053,
    height: 200.001,
    viewBox: "0 0 388.053 200.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.021,
    y1: 0.197,
    x2: 0.935,
    y2: 0.775,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4e6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91636e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.403,
    y1: -1.281,
    x2: 0.548,
    y2: 1.133,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#995d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a5a71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7c5770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#73566f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71566f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#746a97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#826484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945f6e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173403",
    "data-name": "Path 173403",
    d: "M388.053,8.923v181.83c0,4.916-4.914,8.907-10.966,8.907H10.966C4.914,199.659,0,195.668,0,190.753V8.923C0,3.991,4.914,0,10.966,0h366.12C383.139,0,388.053,3.991,388.053,8.923Z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173404",
    "data-name": "Path 173404",
    d: "M0,30.8S69.273,81.608,171.284.2H7.219C3.228.2,0,4.3,0,9.382Z",
    transform: "translate(0 0.125)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173405",
    "data-name": "Path 173405",
    d: "M105.57,165.254S125.784,35.793,249.47,58.506V155.7a9.562,9.562,0,0,1-9.555,9.555H105.57Z",
    transform: "translate(138.583 34.746)",
    fill: "url(#linear-gradient-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.1bec0128e8e6523363a43bb16f1b2359.svg";
export { ForwardRef as ReactComponent };